<mat-form-field appearance="outline" class="station-select-field full-width" subscriptSizing="dynamic">
  <mat-label>{{ label }}@if (required) { *}</mat-label>
  <input
    matInput
    type="text"
    [placeholder]="placeholder"
    [formControl]="searchControl"
    [matAutocomplete]="stationAuto"
    (blur)="onBlur()"
  />
  <mat-icon matSuffix>radio</mat-icon>
  <mat-autocomplete
    #stationAuto="matAutocomplete"
    (opened)="onPanelOpened()"
    (optionSelected)="onStationSelected($event)">
    @if (visibleStations.length === 0) {
      <mat-option disabled>No stations found</mat-option>
    } @else {
      @for (station of visibleStations; track station.id) {
        <mat-option [value]="station.id">
          <span class="option-line">
            <span class="option-name">{{ station.name }}</span>
            <span class="option-call-sign">{{ station.call_sign }}</span>
          </span>
        </mat-option>
      }
    }
  </mat-autocomplete>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
